<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>as always</i>—</span></p>
<p class="ded1"><span><i>for Amy</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2d83469e